import Vue from "vue";
import VueRouter from "vue-router";
import beforeEach from "./beforeEach";
import Main from "../modules/main/Main.vue";
import Auth from "../modules/auth/Auth.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "Home" },
  },
  {
    path: "/",
    name: "Main",
    redirect: { name: "Home" },
    component: Main,
    children: [
      {
        path: "home",
        name: "Home",
        meta: { title: "Dashboard", requiresAuth: true },
        component: () => import("@/modules/main/views/home/Home.vue"),
      },
      {
        path: "assets",
        redirect: { name: "AssetsList" },
        component: () => import("@/modules/main/views/assets/Assets.vue"),
        children: [
          {
            path: "",
            name: "AssetsList",
            meta: { title: "Empreendimentos", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/assets/children/AssetsList/AssetsList.vue"
              ),
          },
          {
            path: ":id",
            name: "AssetDetails",
            meta: { title: "Detalhe do empreendimento", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/assets/children/AssetDetails/AssetDetails.vue"
              ),
          },
        ],
      },
      {
        path: "transactions",
        name: "Transactions",
        meta: { title: "Transações", requiresAuth: true },
        component: () =>
          import("@/modules/main/views/transactions/Transactions.vue"),
      },
      {
        path: "users",
        redirect: { name: "UsersList" },
        component: () => import("@/modules/main/views/users/Users.vue"),
        children: [
          {
            path: "",
            name: "UsersList",
            meta: { title: "Usuários", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/users/children/UsersList/UsersList.vue"
              ),
          },
          {
            path: ":id",
            name: "UserDetails",
            meta: { title: "Perfil do usuário", requiresAuth: true },
            component: () =>
              import(
                "@/modules/main/views/users/children/UserDetails/UserDetails.vue"
              ),
          },
        ],
      },
    ],
  },
  {
    path: "/auth",
    name: "Auth",
    redirect: { name: "SignIn" },
    component: Auth,
    children: [
      {
        path: "sign-in",
        name: "SignIn",
        meta: { title: "Entrar", preventAuth: true },
        component: () => import("@/modules/auth/views/signIn/SignIn.vue"),
      },
    ],
  },
  {
    path: "*",
    redirect: { name: "Home" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(beforeEach);

export default router;
